import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { extractLocaleFromPath, localePath } from '@/lib/routes'
import { SUPPORTED_LOCALES, type SupportedLocale } from '@/i18n'
import { track } from '@/lib/analytics'

export function LanguageSwitcher() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { locale, rest } = extractLocaleFromPath(pathname)

  const onChange = (next: SupportedLocale) => {
    if (next === locale) return
    track('locale_switched', { from: locale, to: next })
    const stripped = rest.startsWith('/') ? rest.slice(1) : rest
    navigate(localePath(next, stripped))
  }

  return (
    <label className="text-xs opacity-75 inline-flex items-center gap-2">
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={locale}
        onChange={(e) => onChange(e.target.value as SupportedLocale)}
        className="bg-transparent border border-mono-700 dark:border-mono-700 rounded px-2 py-1
          text-mono-700 dark:text-mono-300"
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l}>
            {t(`language.${l}`)}
          </option>
        ))}
      </select>
    </label>
  )
}
